{
   "search":"search",
   "pagination":"pagination",
   "custom-column":"custom-column",
   "export-btn" : "export-btn",
   "date-picker":"date-picker",
   "bulk-upload":"bulk-upload",
   "common":"common"
}